import { ServerErrorStatus } from '@agilox/common';
import { ButtonComponent } from '@agilox/ui';
import { DOCUMENT } from '@angular/common';
import { Component, computed, inject, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

enum ErrorType {
	SERVER = 'server',
	FORBIDDEN = 'forbidden',
}

@Component({
	selector: 'error-page',
	templateUrl: './error-page.component.html',
	imports: [ButtonComponent, TranslateModule],
	host: { class: 'block' },
})
export class ErrorPageComponent {
	private document = inject(DOCUMENT);

	status = input.required<ServerErrorStatus>();

	logout = output<void>();

	variant = computed<ErrorType>(() =>
		this.status() === ServerErrorStatus.UNAUTHORIZED ||
		this.status() === ServerErrorStatus.FORBIDDEN
			? ErrorType.FORBIDDEN
			: ErrorType.SERVER
	);

	code = computed(() => (this.variant() === ErrorType.FORBIDDEN ? '403' : '500'));

	retry(): void {
		this.document.defaultView?.location.reload();
	}
}
